import { runOnFeatureInit } from '@frontend/vanilla/core';

import { MediaWidgetRegistration } from './media-widget.registration';

export function provide() {
    return [runOnFeatureInit(MediaWidgetRegistration)];
}
